import { Alert, AlertProps } from "antd"

export default function OSAlert(props: AlertProps) {
  const { className, type, ...rest } = props
  const isError = type === "error"
  return (
    <Alert
      {...rest}
      type={type}
      className={`${className} text-xs ${
        isError ? "dark:bg-red-600 bg-red-500 text-white" : ""
      }`}
    />
  )
}
